export default "__VITE_PUBLIC_ASSET__c3bc4f0f__"